/**
 * SLA / hatırlatma sabitleri — token süresi yok; 2 gün sonra hatırlatma maili.
 */
export const REMINDER_AFTER_DAYS = 2
export const REMINDER_COOLDOWN_DAYS = 2

const MS_PER_DAY = 24 * 60 * 60 * 1000

export const addDaysIso = (fromDate, days) =>
  new Date(new Date(fromDate).getTime() + days * MS_PER_DAY).toISOString()

/**
 * Referans tarihten itibaren hatırlatma eşiği aşıldı mı?
 */
export const isPastReminderThreshold = (referenceIso, now = new Date(), afterDays = REMINDER_AFTER_DAYS) => {
  if (!referenceIso) return false
  const ref = new Date(referenceIso).getTime()
  if (Number.isNaN(ref)) return false
  return now.getTime() - ref >= afterDays * MS_PER_DAY
}

/**
 * Son hatırlatmadan bu yana cooldown doldu mu? (hiç gönderilmediyse true)
 */
export const canSendReminder = (lastReminderAt, now = new Date(), cooldownDays = REMINDER_COOLDOWN_DAYS) => {
  if (!lastReminderAt) return true
  const last = new Date(lastReminderAt).getTime()
  if (Number.isNaN(last)) return true
  return now.getTime() - last >= cooldownDays * MS_PER_DAY
}
